import { defineStore } from 'pinia';
import { ref, computed } from 'vue';
import { SessionStorage } from 'quasar'
import api from '../services/api'


export const useInvitationStore = defineStore('invitation', () => {
  const invitationToken = ref(null)
  /**
   * @type {Ref<Invitation>}
   */
  const invitation = ref({
    inviter: {},
    workspace: {}
  })
  const showWelcomeMessage = ref(false)

  async function acceptInvitation() {
    await api.acceptInvitation(invitation.value.workspace.id, invitation.value.id)
    $reset()
    showWelcomeMessage.value = true
  }

  function $reset() {
    invitationToken.value = null
    invitation.value = {
      inviter: {},
      workspace: {}
    }
    SessionStorage.remove('invitation')
  }

  async function init(inviteString) {
    if (inviteString === 'reset') {
      $reset()
      return
    }
    if (inviteString) {
      const [workspaceId, invitationId] = inviteString.split('.')
      if (!workspaceId || !invitationId) {
        $reset()
        return
      }
      invitationToken.value = inviteString
      const invite = await api.getInvitationDetails(workspaceId, invitationId)
      if (!invite) {
        $reset()
        return
      }
      invitation.value = invite
      SessionStorage.set('invitation', { token: inviteString, invitation: invite })
    }
    const inv = SessionStorage.getItem('invitation')
    if (inv) {
      invitationToken.value = inv.token
      invitation.value = inv.invitation
    }
  }

  return {
    $reset,
    acceptInvitation,
    init,
    invitationToken,
    invitation,
    showWelcomeMessage
  }
})

/**
 * @typedef Invitation
 * @property {String} id
 * @property {String} createTime
 * @property {String} expires
 * @property {String} email
 * @property {Object} roles
 * @property {'NONE'|'VIEW'|'MANAGE'} roles.data
 * @property {'NONE'|'MANAGE'} roles.forms
 * @property {'NONE'|'VIEW'|'INVITE'|'MANAGE'} roles.team
 * @property {'VIEW'|'MANAGE'} roles.workspace
 * @property {Object} workspace
 * @property {String} workspace.id
 * @property {String} workspace.color
 * @property {String} workspace.name
 * @property {Object} inviter
 * @property {String} inviter.name
 * @property {String} inviter.email
 */
